import { useAtom } from 'jotai';
import { fitToScreenAtom } from '../atoms/stage-atoms';
export function useFitToScreen(): [() => void, (handler: () => void) => void] {
  return useAtom(fitToScreenAtom);
}